import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--primary);
  color: var(--btn-text);
  flex-shrink: 0;

  svg {
    width: 22px;
    height: 22px;
  }
`;

const TitleText = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.5px;
  line-height: 1.2;
`;

const Subtitle = styled.p`
  font-size: 13px;
  color: var(--text-muted);
  margin: 2px 0 0 0;
  font-weight: 400;
`;

const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const PageHeader = ({ icon: Icon, title, subtitle, children }) => (
  <HeaderContainer>
    <TitleRow>
      {Icon && (
        <IconWrapper>
          <Icon />
        </IconWrapper>
      )}
      <TitleGroup>
        <TitleText>{title}</TitleText>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </TitleGroup>
    </TitleRow>
    {children}
  </HeaderContainer>
);

export default PageHeader;
